import { createClient } from "@supabase/supabase-js";

// These project identifiers are intentionally public browser credentials. Environment
// variables can override them, while the fallbacks keep Cloudflare Pages direct-upload
// builds functional because ignored .env.local files are never uploaded.
const url = import.meta.env.VITE_SUPABASE_URL || "https://okvagxtupapbywxwbfrb.supabase.co";
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || "sb_publishable_E5u_YP6VwGBK64rz-rN8wQ_McTWb_mU";
const missing = [
  !url && "VITE_SUPABASE_URL",
  !publishableKey && "VITE_SUPABASE_PUBLISHABLE_KEY (or VITE_SUPABASE_ANON_KEY)",
].filter(Boolean);
export const configurationIssue = missing.length ? `Missing browser configuration: ${missing.join(", ")}. Rebuild the site after adding it.` : null;

export const supabase = createClient(url || "https://configuration.invalid", publishableKey || "configuration-missing", {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
